<!-- Takes an asset and shows the asset name -->
<template lang="pug">
p(v-if="error") {{ $t("error") }}
p(v-else-if="loading", v-loading="true") 
p(v-else-if="props.id === undefined && props.twin === undefined") -
router-link.asset-link(
  v-else-if="loaded && linkName !== null",
  :to="{ name: linkName, params: { template: assetTemplate, id: id } }"
) {{ assetName }}
.asset-link(v-else-if="loaded") {{ assetName }}
p(v-else) -
</template>

<script setup lang="ts">
import { getTwin } from "@shared/services/twinManagement";
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useTwinStore } from "../../../stores/twinManagement";
import { useAppStore } from "../../../stores/apps";
import { useTwinCacheStore } from "@shared/stores/twinCache";

const props = defineProps<{
  id?: string;
  twin?: {
    name: string;
    uuid: string;
    templateId?: string;
    templateUuid?: string;
  };
}>();

onMounted(() => {
  if (props.id) {
    loadSelectedTwin();
  } else if (props.twin) {
    twinStore.getTwinTemplates();
  } else {
    console.warn("Twin Field: Either id or twin has to be set");
  }
});

const twinLoadState = computed(() => {
  return twinCacheStore.twinBaseCache.get(props.id);
});

const loading = computed(() => twinLoadState.value?.loading);
const loaded = computed(() => {
  return props.twin ? true : twinLoadState.value?.loaded;
});
const error = computed(() => twinLoadState.value?.error);

const assetTemplate = computed(() => {
  if (props.twin) {
    return props.twin.templateId
      ? props.twin.templateId
      : props.twin.templateUuid;
  }
  return twinLoadState.value?.result?.templateUuid;
});
const assetName = computed(() =>
  props.twin ? props.twin.name : twinLoadState.value?.result?.name,
);

const appStore = useAppStore();
const twinStore = useTwinStore();

const linkName = computed(() => {
  const template = twinStore.templatesLoadingState.result?.find(
    (item) => item.uuid === assetTemplate.value,
  );
  if (template) {
    return appStore.getLink(
      `twin-edit.${template.type}.${assetTemplate.value}.${id.value}`,
    )?.routeName;
  }
  return null;
});

const id = computed(() => {
  return props.twin ? props.twin.uuid : props.id;
});

const twinCacheStore = useTwinCacheStore();

async function loadSelectedTwin() {
  if (props.id) {
    await twinCacheStore.loadTwinBase(props.id);
  }
}

watch(
  () => props.id,
  () => {
    twinCacheStore.loadTwinBase(props.id);
  },
);
</script>

<style>
.asset-link {
  color: var(--color-orange-dark);
}
</style>
